import "./RiskDashboardNotificationsComponent.scss";
import {RiskDashboardNotifications as Notifications} from "../../models/RiskDashboardNotifications";
import {NotificationType} from "./NotificationType";
import {RiskDashboardViewStore} from "../../store/RiskDashboardViewStore";
import {IOnDestroy, IOnInit, IScope} from "angular";
import {ReplaySubject} from "rxjs";
import {AdviserFilter, ClientFilter, ModelFilter, NoOpModelFilter} from "../../models/filtering/ModelFilter";
import {isOverCbplLimit, isOverMarginLimit, isOverStelLimit, requiresMarginLimit} from "../../util/RiskRowUtil";

export const RiskDashboardNotifications = "riskDashboardNotifications";

export function riskDashboardNotifications() {
    return {
        templateUrl: "app/risk/dashboard/components/notifications/RiskDashboardNotificationsComponent.html",
        bindings: {
            viewStore: "<"
        },
        controllerAs: "ctrl",
        controller: RiskDashboardNotificationsComponentController
    };
}

export class RiskDashboardNotificationsComponentController implements IOnInit, IOnDestroy {

    public readonly viewStore: RiskDashboardViewStore;

    public notifications: Notifications;
    public currentFilter: NotificationType | null;

    private readonly destroyed$ = new ReplaySubject<boolean>(1);

    /** @ngInject */
    public constructor(private $scope: IScope) {

    }

    public $onInit(): void {
        this.viewStore
            .notifications
            .takeUntil(this.destroyed$)
            .do((notifications) => this.notifications = notifications)
            .do(() => this.$scope.$applyAsync())
            .subscribe();
        this.viewStore
            .activeNotification
            .takeUntil(this.destroyed$)
            .do((active) => this.currentFilter = active)
            .do(() => this.$scope.$applyAsync())
            .map((active) => this.buildModelFilter(active))
            .subscribe((filter) => this.viewStore.updateModelFilter(filter));
    }

    public onNotificationClicked(filter: NotificationType) {
        this.viewStore.toggleNotificationSelection(filter);
    }

    private buildModelFilter(notificationType: NotificationType | null): ModelFilter {
        if (notificationType == null) {
            return NoOpModelFilter();
        }
        switch (notificationType) {
            case NotificationType.ADVISER_STEL:
                return AdviserFilter(isOverStelLimit);
            case NotificationType.CLIENT_STEL:
                return ClientFilter(isOverStelLimit);
            case NotificationType.CLIENT_NO_MARGIN:
                return ClientFilter(requiresMarginLimit);
            case NotificationType.CLIENT_MARGIN_BREACH:
                return ClientFilter(isOverMarginLimit);
            case NotificationType.CLIENT_INITIAL_MARGIN:
                return ClientFilter(isOverCbplLimit);
        }
    }

    public $onDestroy(): void {
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }
}
